import axios from '@/util/axios'
import axiosNoError from '@/util/axios_no_error'
import { API_RELAY_PATH } from '@/util/constants'
import { isFromAdminSystem } from '@/util/common'
import store from '@/store'

/**
 * ノート一覧API
 * @param  {} params={}
 */
export const list = (params = {}) => {


  const defaults = {
    _path: 'NT/001',
    token: store.state.auth.token,
    start: 0,
    per_page: 30
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * ノート一覧件数取得API
 * @param  {} params={}
 */
export const count = (params = {}) => {
  const defaults = {
    _path: 'NT/002',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * ノート利用者一覧API
 * @param  {} params={}
 */
export const listUsers = (params = {}) => {
  const defaults = {
    _path: 'NT/003',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * ノートタグ一覧API
 */
export const listNoteTags = (params = {}) => {
  const defaults = {
    _path: 'NT/004',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * ノート詳細API
 */
export const detail = (params = {}) => {
  const defaults = {
    _path: 'NT/005',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * ノート追加API
 */
export const add = (params = {}) => {
  const defaults = {
    _path: 'NT/006',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * ノート行追加API
 */
export const addNoteLine = (params = {}) => {
  const defaults = {
    _path: 'NT/007',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * ノート複製API
 */
export const copy = (params = {}) => {
  const defaults = {
    _path: 'NT/008',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * ノート更新API
 */
export const update = (params = {}) => {
  const defaults = {
    _path: 'NT/009',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * ノート削除API
 */
export const remove = (params = {}) => {
  const defaults = {
    _path: 'NT/010',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * ノート用QA詳細取得API
 * @param  {} params={}
 */
export const qaDetail = (params = {}) => {
  const defaults = {
    _path: 'NT/011',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * ノート利用者権限一覧API
 * @param  {} params={}
 */
export const getUserPermissions = (params = {}) => {
  const defaults = {
    _path: 'NT/012',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * ノート利用者権限更新API
 * @param  {} params={}
 */
export const updateUserPermissions = (params = {}) => {
  const defaults = {
    _path: 'NT/013',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}
